import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Dialog, TableRow, TableCell, Tooltip, IconButton, Checkbox, Chip } from "@material-ui/core";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import ConfirmDialog from "../components/ConfirmDialog";
import { fillSvEditFormApi } from "../apiServices";
import SvTaskForm from "./SvTaskForm";
import moment from "moment";
import { regexConstants } from "../../../../constants/regEx";
import { dayMonthDateFormat } from "../../../../constants"
import ShowAttachments from "../../../../shared_elements/components/ShowAttachments";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { permissionCheckFnforCamo, checkApiStatus, Comma_format } from "../../../../utils";
import { globalPutService, globalDeleteService } from "../../../../utils/globalApiServices";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import Switch from '@material-ui/core/Switch';
import { smbcInstance } from "../../../../shared_elements/components";
const SvList = ({ item, index, handleDeleteRow, updateFormData, props, fileUploadData, currentRecordPerPage, downloadAllApi, uuid, last_used_folder_uuid, getResponseBack, last_used_folder_uuid_link_document, checkbox_last_used_folder_uuid, checkbox_last_used_folder_name, assetsDetail, bulkOperation, toggleBulkOps, basicDetail, techSpecDetail, basicDetails }) => {
    const [open, setOpen] = useState(false);
    const [openEditForm, setEditForm] = useState(false);
    const [editFormId, setEditFormId] = useState(null);
    const [editFormData, setEditFormData] = useState(null);
    const [formTitle, setFormTitle] = useState("");
    const [attachments, setAttachments] = useState(null);
    const [showFullDescription, setShowFullDescription] = useState({});
    const [openGetAttachmentsDialogue, setAttachmentsDialogue] = useState(false);
    const [AllAttachmentsforDialogue, setAllAttachmentsforDialogue] =
        useState(null);
    const [moduleId, setmoduleId] = useState(null);
    const [actionType, setActionType] = useState("");
    const [svToggel, setSvTogle] = useState(item?.sv_reset_tslsv_cslsv)

    useEffect(() => {
        setSvTogle(item?.sv_reset_tslsv_cslsv);
    }, [item?.sv_reset_tslsv_cslsv])


    const handleClick = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const closeAddForm = () => {
        setEditForm(false);
    };

    const handleEditRow = () => {
        fillSvEditFormApi(item, props).then((response) => {
            setEditFormData(response.data.data);
            setEditFormId(response.data.data.id);
            setAttachments(response.data.data.attachments);
            setFormTitle("Update Shop Visit");
            setEditForm(true);
            setActionType('edit')
        });
    };

    const downAllAttach = () => {
        fillSvEditFormApi(item, props).then((response) => {
            setmoduleId(response.data.data.id);
        });
        getAttachements()
    };
    const getAttachements = () => {
        const matchingItem = assetsDetail?.list?.find(items => items?.id === item.id);
        if (!matchingItem) return;
        const combined = [
            ...(matchingItem.attachments || []),
            ...(matchingItem.checklist?.files || []),
            ...(matchingItem.checklist?.folders || []),
        ];
        if (combined.length > 0) getAttachments(combined);
    };

    const openAttachment = (file) => {
        var decodedURL = decodeURIComponent(file);
        window.open(decodedURL, "_blank");
    };

    const formatDate = (date) => {
        return moment(date).format(dayMonthDateFormat);
    };

    const toggleDescription = (id) => {
        setShowFullDescription({
            ...showFullDescription,
            [id]: !showFullDescription[id],
        });
    };

    const getAttachments = (attachments) => {
        setAllAttachmentsforDialogue(attachments);
        setAttachmentsDialogue(true);
    };

    const handleCloseAttachmentDialogue = () => {
        setAttachmentsDialogue(false);
    };

    const resetTslvCslv = (flag) => {
        globalPutService(`camo/shop/reset_tslsv_cslsv/${item?.id}/?reset=${!flag}`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setSvTogle(response?.data?.data?.sv_reset_tslsv_cslsv)
                    props.enqueueSnackbar(response.data.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, });
                    window.location.reload()
                } else {
                    props.enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
                }
            })
    }
    const buildAttachmentList = (updatedData) => [
        ...(item?.attachments?.length > 0 ? updatedData.attachments || [] : []),
        ...(item?.checklist?.files?.length > 0 ? updatedData.checklist?.files || [] : []),
        ...(item?.checklist?.folders?.length > 0 ? updatedData.checklist?.folders || [] : []),
    ];

    const refreshAttachmentsAfterRemove = () => {
        fillSvEditFormApi(item, props).then((response) => {
            setEditFormData(response.data.data);
            const combined = buildAttachmentList(response.data.data);
            if (combined.length > 0) getAttachments(combined);
            getResponseBack();
        });
    };

    const removeAttachment = (item, checklist, fileId, uuid) => {
        if (uuid) {
            const payload = {
                delete: true,
                folder_ids: checklist.filter(i => i.type === 'folder').map(f => f.id).filter(id => id !== fileId).toString(),
                file_ids: checklist.filter(i => i.type === 'file').map(f => f.id).filter(id => id !== fileId).toString(),
            };
            globalPutService(`camo/shop/${item?.id}/document-checklists/`, payload)
                .then((response) => {
                    if (checkApiStatus(response)) refreshAttachmentsAfterRemove();
                });
        } else {
            globalDeleteService(`camo/attachment/${fileId}/delete/`).then((response) => {
                if (response.status === 500) {
                    props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
                } else if (response) {
                    refreshAttachmentsAfterRemove();
                }
            });
        }
    };
    let timezone = moment().format()
    const timestamp = Math.floor(Date.now() / 1000);
    const svurl = `audit/camo/shopvisit/?object_id=${item.id}&action=0,1&timezone=${timezone}&timestamp=${timestamp}`

    const attachmentCount = (item.attachments?.length || 0)
        + (item.checklist?.files?.length || 0)
        + (item.checklist?.folders?.length || 0) || '--';

    const selectedItem = bulkOperation.ids.find(data => data.id === item?.id);
    return (
        <>
            <TableRow
                hover
                tabIndex={-1}
                style={{ cursor: "pointer" }}
                className="shopVist-listing"
            >
                {!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D" }) || window?.location?.search.includes('archived-assets') ? null : <TableCell width="30">
                    <Checkbox
                        name={item.id}
                        color="primary"
                        size="small"
                        onChange={(e) => toggleBulkOps(e.target.checked)}
                        checked={selectedItem ? true : false}
                    />
                </TableCell>}
                <TableCell className="sv-action">
                    {!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" }) || window?.location?.search.includes('archived-assets') ? null : (
                        <Tooltip title="Edit" arrow placement="top">
                            <IconButton
                                className="edit-icon"
                                onClick={(e) => {
                                    handleEditRow(e);
                                }}
                            >
                                <CreateOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                    {!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D" }) || window?.location?.search.includes('archived-assets') ? null : (
                        <Tooltip title="Delete" arrow placement="top">
                            <IconButton className="delete-icon" onClick={handleClick}>
                                <DeleteOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                    <RevisionHistory buttonType={true} url={svurl} />
                    {!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" }) || window?.location?.search.includes('archived-assets') ? null : <Tooltip title={smbcInstance ? "Reset TSPR/CSPR" : "Reset TSLSV/CSLSV"} arrow placement="top">
                        <span>
                            <Switch
                                className="sv-reset-tslsv-cslsv"
                                checked={svToggel}
                                onChange={() => resetTslvCslv(svToggel)}
                                color="primary"
                                id="sv_reset_tslsv_cslsv"
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                        </span>
                    </Tooltip>}
                </TableCell>
                <TableCell>{item.removal_date ? formatDate(item?.removal_date) : "--"} </TableCell>
                <TableCell style={{ minWidth: "180px" }}>
                    {item?.engine_module_data?.length
                        ? [...new Set(item?.engine_module_data?.map(e => e?.module_name).filter(Boolean))]?.map((name, i) => (
                            <Chip key={i} size="small" label={name} style={{ margin: '2px' }} />
                        ))
                        : '--'}
                </TableCell>
                <TableCell style={{ minWidth: "180px" }}>
                    {item.removal_reason && item.removal_reason.length > 150 ? (
                        <div>
                            {showFullDescription[item.id] ? (
                                <span>
                                    {item.removal_reason}
                                    <a
                                        href="#"
                                        style={{ color: "#0e7fe1" }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            toggleDescription(item.id);
                                        }}
                                    >
                                        ..less
                                    </a>
                                </span>
                            ) : (
                                <span>
                                    {item.removal_reason.substring(0, 150)}
                                    <a
                                        href="#"
                                        style={{ color: "#0e7fe1" }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            toggleDescription(item.id);
                                        }}
                                    >
                                        ..more
                                    </a>
                                </span>
                            )}
                        </div>
                    ) : item.removal_reason && item.removal_reason.length <= 150 ? (
                        <span>{item.removal_reason}</span>
                    ) : (
                        "--"
                    )}
                </TableCell>
                <TableCell>{item.tsn_at_removal ? regexConstants.alphanumespcespclchar.test(item.tsn_at_removal) ? item.tsn_at_removal : Comma_format(item.tsn_at_removal) : "--"}</TableCell>
                <TableCell>{item.csn_at_removal ? regexConstants.alphanumespcespclchar.test(item.csn_at_removal) ? item.csn_at_removal : Comma_format(item.csn_at_removal) : "--"}</TableCell>
                <TableCell> {item.sv_completion_date ? formatDate(item.sv_completion_date) : "--"} </TableCell>
                <TableCell>{item.sv_location_mro ? item.sv_location_mro : "--"}</TableCell>
                <TableCell> {item.sv_workscope ? item.sv_workscope : "--"} </TableCell>
                <TableCell> {item.sv_type ? item.sv_type : "--"} </TableCell>
                <TableCell>
                    {attachmentCount ? (
                        <>
                            <Tooltip title="View Attachments" arrow placement="top">
                                <span className="center" onClick={() => downAllAttach()} >
                                    <AttachFileIcon className="attach-icon" />
                                    <a href="#" style={{ color: "#0e7fe1" }}>{attachmentCount}</a>
                                </span>
                            </Tooltip>
                        </>
                    )
                        : (
                            "--"
                        )}
                </TableCell>
            </TableRow>
            <Dialog open={open} onClose={handleClose} id="htDialog">
                <ConfirmDialog
                    handleClose={() => handleClose()}
                    handleDeleteRow={handleDeleteRow}
                />
            </Dialog>
            <Dialog
                position="relative"
                maxWidth="lg"
                open={openEditForm}
            >
                <SvTaskForm
                    actionType={actionType}
                    formTitle={formTitle}
                    closeAddForm={() => closeAddForm()}
                    addForm={() => setEditForm(true)}
                    props={props}
                    editFormId={editFormId}
                    editFormData={editFormData}
                    attachments={attachments}
                    item={item}
                    updateFormData={updateFormData}
                    fileUploadData={fileUploadData}
                    currentRecordPerPage={currentRecordPerPage}
                    uuid={uuid}
                    last_used_folder_uuid={last_used_folder_uuid}
                    last_used_folder_uuid_link_document={last_used_folder_uuid_link_document}
                    checkbox_last_used_folder_uuid={checkbox_last_used_folder_uuid}
                    checkbox_last_used_folder_name={checkbox_last_used_folder_name}
                    getResponseBack={() => getResponseBack()}
                    basicDetail={basicDetail}
                    techSpecDetail={techSpecDetail}
                />
            </Dialog>
            <Dialog
                open={openGetAttachmentsDialogue}
                onClose={handleCloseAttachmentDialogue}
                id="htDialog"
            >
                <ShowAttachments
                    handleClose={() => handleCloseAttachmentDialogue()}
                    handleShowAttachments={AllAttachmentsforDialogue}
                    openAttachment={openAttachment}
                    files={{ title: "Shop Visit", extension: "zip", key: "" }}
                    downloadAllApi={downloadAllApi}
                    moduleId={moduleId}
                    item={item}
                    basicDetails={basicDetails}
                    removeAttachment={removeAttachment}
                />
            </Dialog>
        </>
    );
};
export default withRouter(SvList);